import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Route guard that accepts EITHER a customer JWT (via useAuth) OR a
 * staff JWT (sessionStorage.staff_token). Used for pages that both
 * customers/admins AND pure-staff users need to reach — e.g. the
 * np-packing / mrp-label task manager flows deep-linked from the
 * StaffDashboard "Start Task" buttons.
 *
 * Without this, a phone that exists ONLY in `np_staff` (no customer
 * row) gets a `staff_token` but no customer token, fails
 * `ProtectedRoute.isAuthenticated`, and gets bounced to /auth → login
 * loop.
 */
const StaffOrCustomerRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  const staffToken = (() => {
    try { return sessionStorage.getItem('staff_token'); } catch { return null; }
  })();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated && !staffToken) {
    const intendedUrl = location.pathname + location.search;
    return <Navigate to="/auth" state={{ from: intendedUrl }} replace />;
  }

  return children;
};

export default StaffOrCustomerRoute;
